// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f22394dd","254":"7c089e40","302":"0774a98c","496":"7420522a","630":"8e273b15","878":"db2cfb28"}[chunkId] + ".chunk.js";
};